import './MyContentModal.css';
import { NebulaIcon as U, NebulaButton as P, NebulaModal as R, NebulaTabs as E, NebulaTabItem as j } from "@discoveryedu/nebula-components";
import { a as z } from "./platform-components-assets/index-es.js";
import { a as T, b as k, c as q, d as V, e as G, f as $, m as H, h as J, r as K, i as Q, g as W, j as X } from "./platform-components-assets/myContentApi-es.js";
import { openBlock as i, createBlock as y, Transition as N, withCtx as F, createElementBlock as c, createElementVNode as n, toDisplayString as p, createCommentVNode as f, reactive as Y, resolveComponent as u, normalizeClass as v, Fragment as M, withDirectives as Z, vModelText as ee, withModifiers as B, createVNode as C, renderList as A, createTextVNode as O } from "vue";
import { _ as w } from "./platform-components-assets/_plugin-vue_export-helper-es.js";
const te = {
  name: "LoadingSpinner",
  props: {
    isLoading: {
      type: Boolean
    }
  }
}, se = {
  key: 0,
  class: "my-content-modal__spinner"
}, oe = { class: "comet-spinner comet-spinner--on-light" }, ne = {
  class: "comet-spinner__icon",
  "aria-labelledby": "title",
  viewBox: "-10 -10 220 220"
}, le = /* @__PURE__ */ n("defs", null, [
  /* @__PURE__ */ n("linearGradient", {
    id: "spinner-color-1",
    gradientUnits: "objectBoundingBox",
    x1: "0",
    y1: "0",
    x2: "1",
    y2: "1"
  }, [
    /* @__PURE__ */ n("stop", {
      offset: "0%",
      "stop-color": "#7B869D",
      "stop-opacity": "0"
    }),
    /* @__PURE__ */ n("stop", {
      offset: "100%",
      "stop-color": "#7B869D",
      "stop-opacity": ".2"
    })
  ]),
  /* @__PURE__ */ n("linearGradient", {
    id: "spinner-color-2",
    gradientUnits: "objectBoundingBox",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, [
    /* @__PURE__ */ n("stop", {
      offset: "0%",
      "stop-color": "#7B869D",
      "stop-opacity": ".2"
    }),
    /* @__PURE__ */ n("stop", {
      offset: "100%",
      "stop-color": "#7B869D",
      "stop-opacity": ".4"
    })
  ]),
  /* @__PURE__ */ n("linearGradient", {
    id: "spinner-color-3",
    gradientUnits: "objectBoundingBox",
    x1: "1",
    y1: "0",
    x2: "0",
    y2: "1"
  }, [
    /* @__PURE__ */ n("stop", {
      offset: "0%",
      "stop-color": "#7B869D",
      "stop-opacity": ".4"
    }),
    /* @__PURE__ */ n("stop", {
      offset: "100%",
      "stop-color": "#7B869D",
      "stop-opacity": ".6"
    })
  ]),
  /* @__PURE__ */ n("linearGradient", {
    id: "spinner-color-4",
    gradientUnits: "objectBoundingBox",
    x1: "1",
    y1: "1",
    x2: "0",
    y2: "0"
  }, [
    /* @__PURE__ */ n("stop", {
      offset: "0%",
      "stop-color": "#7B869D",
      "stop-opacity": ".6"
    }),
    /* @__PURE__ */ n("stop", {
      offset: "100%",
      "stop-color": "#7B869D",
      "stop-opacity": ".8"
    })
  ]),
  /* @__PURE__ */ n("linearGradient", {
    id: "spinner-color-5",
    gradientUnits: "objectBoundingBox",
    x1: "0",
    y1: "1",
    x2: "0",
    y2: "0"
  }, [
    /* @__PURE__ */ n("stop", {
      offset: "0%",
      "stop-color": "#7B869D",
      "stop-opacity": ".8"
    }),
    /* @__PURE__ */ n("stop", {
      offset: "100%",
      "stop-color": "#7B869D",
      "stop-opacity": "1"
    })
  ]),
  /* @__PURE__ */ n("linearGradient", {
    id: "spinner-color-6",
    gradientUnits: "objectBoundingBox",
    x1: "0",
    y1: "1",
    x2: "1",
    y2: "0"
  }, [
    /* @__PURE__ */ n("stop", {
      offset: "0%",
      "stop-color": "#7B869D",
      "stop-opacity": "1"
    }),
    /* @__PURE__ */ n("stop", {
      offset: "100%",
      "stop-color": "#7B869D",
      "stop-opacity": "1"
    })
  ])
], -1), ie = /* @__PURE__ */ n("circle", {
  fill: "#7B869D",
  cx: "45%",
  cy: "0",
  r: "7.5"
}, null, -1), de = /* @__PURE__ */ n("g", {
  fill: "none",
  "stroke-width": "20",
  transform: "translate(100,100)"
}, [
  /* @__PURE__ */ n("path", {
    d: "M 0,-100 A 100,100 0 0,1 86.6,-50",
    stroke: "url(#spinner-color-1)"
  }),
  /* @__PURE__ */ n("path", {
    d: "M 86.6,-50 A 100,100 0 0,1 86.6,50",
    stroke: "url(#spinner-color-2)"
  }),
  /* @__PURE__ */ n("path", {
    d: "M 86.6,50 A 100,100 0 0,1 0,100",
    stroke: "url(#spinner-color-3)"
  }),
  /* @__PURE__ */ n("path", {
    d: "M 0,100 A 100,100 0 0,1 -86.6,50",
    stroke: "url(#spinner-color-4)"
  }),
  /* @__PURE__ */ n("path", {
    d: "M -86.6,50 A 100,100 0 0,1 -86.6,-50",
    stroke: "url(#spinner-color-5)"
  }),
  /* @__PURE__ */ n("path", {
    d: "M -86.6,-50 A 100,100 0 0,1 0,-100",
    stroke: "url(#spinner-color-6)"
  })
], -1);
function re(e, s, o, d, l, t) {
  return i(), y(N, { name: "fade" }, {
    default: F(() => [
      o.isLoading ? (i(), c("div", se, [
        n("div", oe, [
          (i(), c("svg", ne, [
            n("title", null, p(e.$t("Loading")), 1),
            le,
            ie,
            de
          ]))
        ])
      ])) : f("", !0)
    ]),
    _: 1
  });
}
const L = /* @__PURE__ */ w(te, [["render", re]]), _ = (e) => e.map((s) => ({
  ...s,
  children: s.type && s.type.id !== "89cb88bc-1b04-4de2-8986-e82f65df2755" ? void 0 : [],
  paging: null
  // the paging property needs to be set here so it can be reactive later
})), I = (e, {
  appendItems: s,
  id: o,
  children: d,
  paging: l
}) => {
  e.id === o ? (e.children = s ? [...e.children, ...d] : [...d], e.paging = l) : e.children && e.children.forEach((t) => {
    I(t, {
      appendItems: s,
      id: o,
      children: d,
      paging: l
    });
  });
}, x = Y({
  // State
  modalIsActive: !1,
  selectMultiple: !1,
  selectedAssets: [],
  selectedFolder: null,
  isCreatingNewFolder: !1,
  type: {
    isTypeAdd: !1,
    isTypeCopy: !1,
    isTypeMove: !1,
    isTypeRestore: !1
  },
  tokens: {
    add: null,
    copy: null,
    move: null,
    create: null,
    addToRootFolderToken: null,
    restore: null
  },
  myUploadsFolder: {
    children: [],
    title: "My Uploads",
    root: !0,
    id: null,
    paging: null
  },
  rootFolder: {
    children: [],
    title: "My Content",
    root: !0,
    id: "root",
    paging: null
  },
  rootFolderIds: null,
  loadingFolders: !1,
  // Actions
  async initMyContent({ config: e, isChooseModal: s }) {
    const { tab: o, isActive: d, selectMultiple: l } = e;
    if (this.showModal(d), this.loadingFolders = !0, s) {
      const t = await T({
        rootOwner: o.type
      });
      let a;
      return o.type === "user" && (a = await T({
        rootType: 5
      })), this.setInitMyContent({
        rootFolder: {
          paging: t.paging,
          children: _(t.mycontent)
        },
        myUploadsFolder: {
          paging: a ? a.paging : {},
          children: a ? _(a.mycontent) : [],
          id: a && a.folder_id
        },
        tab: o.label,
        id: t.folder_id,
        selectMultiple: l
      }), this.loadingFolders = !1, this.selectedFolder = t.folder_id, !0;
    }
    return k(null, o.type).then((t) => {
      const a = {
        addToken: t.tokens.add_to_folder,
        createToken: t.tokens.create,
        copyToken: t.tokens.copy,
        moveToken: t.tokens.move,
        restoreToken: t.tokens.restore,
        addToRootFolderToken: t.tokens.add_to_root_my_content_folder,
        moveToTrashToken: t.tokens.trash
      }, h = t.root_folder_ids;
      this.rootFolderIds || (this.rootFolderIds = h);
      const m = {
        rootFolder: {
          children: t.folders.length ? _(t.folders) : []
        },
        tab: o.label,
        id: h[o.type]
      };
      this.setInitMyContent(m), this.setTokens(a), this.loadingFolders = !1, this.selectedFolder = h[o.type];
    });
  },
  fetchNestedFolder({
    id: e,
    isChooseModal: s,
    page: o,
    tab: d
  }) {
    try {
      return s ? T({
        folderId: e,
        page: o,
        rootOwner: d,
        rootType: e === this.myUploadsFolder.id ? 5 : void 0
      }).then((l) => {
        this.setFolderChild({
          appendItems: !!o,
          id: e,
          children: _(l.mycontent),
          paging: l.paging
        });
      }) : k(e, d).then((l) => {
        this.setFolderChild({
          id: e,
          children: _(l.folders)
        });
      });
    } catch {
      return null;
    }
  },
  setFolderChild(e) {
    this.myUploadsFolder.id && I(this.myUploadsFolder, e), I(this.rootFolder, e);
  },
  setTokens(e) {
    this.tokens.add = e.addToken, this.tokens.create = e.createToken, this.tokens.copy = e.copyToken, this.tokens.move = e.moveToken, this.tokens.restore = e.restoreToken, this.tokens.addToRootFolderToken = e.addToRootFolderToken, this.tokens.trash = e.moveToTrashToken;
  },
  addNewContentFolder({
    folderParentId: e,
    title: s,
    tab: o
  }) {
    return q({
      folderParentId: e,
      title: s,
      token: this.tokens.create,
      tab: o
    }).then(() => {
      this.fetchNestedFolder({ id: e, tab: o }), this.showAddNewFolder(!1);
    });
  },
  addAssetToFolder({
    folderId: e,
    assetId: s,
    tab: o
  }) {
    return e === "root" ? V({
      assetId: s,
      tab: o,
      token: this.tokens.addToRootFolderToken
    }).then(() => {
      this.modalIsActive = !1;
    }) : G({
      folderId: e,
      assetId: s,
      tab: o,
      token: this.tokens.add
    }).then(() => {
      this.modalIsActive = !1;
    });
  },
  copyAssetToFolder({
    targetFolderId: e,
    assetId: s,
    tab: o
  }) {
    return $({
      targetFolderId: e,
      assetId: s,
      tab: o,
      token: this.tokens.copy
    }).then(() => {
      this.modalIsActive = !1;
    });
  },
  moveAssetToFolder({
    targetFolderId: e,
    currentFolderId: s,
    assetId: o,
    tab: d
  }) {
    return H({
      targetFolderId: e,
      currentFolderId: s,
      assetId: o,
      tab: d,
      token: this.tokens.move
    }).then(() => {
      this.modalIsActive = !1;
    });
  },
  moveAssetToTrash(e) {
    const {
      assetId: s,
      currentFolderId: o,
      tab: d
    } = e;
    return J({
      currentFolderId: o,
      assetId: s,
      tab: d,
      token: this.tokens.trash
    }).then(() => {
      this.modalIsActive = !1;
    });
  },
  restoreAssetFromTrash(e) {
    const { folderId: s, assetId: o, tab: d } = e;
    return k(s, d).then((l) => {
      const { restore: t } = l.tokens;
      return K(s, o, d, t).then(() => {
        this.modalIsActive = !1;
      });
    });
  },
  setInitMyContent(e) {
    const {
      rootFolder: s,
      myUploadsFolder: o,
      tab: d,
      id: l,
      selectMultiple: t
    } = e;
    this.rootFolder.children = s.children, this.rootFolder.paging = s.paging, o && (this.myUploadsFolder.children = o.children, this.myUploadsFolder.paging = o.paging, this.myUploadsFolder.id = o.id), this.rootFolder.title = d, this.rootFolder.id = l, this.selectMultiple = t, this.selectedAssets = [];
  },
  toggleSelectedAsset(e) {
    const s = this.selectedAssets.find((o) => o.id === e.id);
    if (!this.selectMultiple) {
      this.selectedAssets = s ? [] : [e];
      return;
    }
    s ? this.selectedAssets = this.selectedAssets.filter((o) => o.id !== e.id) : this.selectedAssets.push(e);
  },
  selectFolder(e) {
    this.selectedFolder = e;
  },
  showAddNewFolder(e) {
    this.isCreatingNewFolder = e;
  },
  showModal(e) {
    this.modalIsActive = e;
  }
}), ae = {
  name: "FolderParent",
  components: {
    NebulaIcon: U,
    LoadingSpinner: L
  },
  props: {
    options: {
      type: Object,
      required: !0
    },
    isChooseModal: Boolean,
    isImagesOnly: {
      type: Boolean
    },
    isFromMyContent: {
      type: Boolean,
      default: !1
    },
    assetId: {
      type: String
    },
    selectedTab: {
      type: Object
    }
  },
  data() {
    return {
      folderOpened: !1,
      folderTitle: "",
      folderIsLoading: !1,
      loadMoreObserver: null
    };
  },
  computed: {
    mycontent() {
      const { myContent: e } = this.options;
      return e;
    },
    nextPage() {
      return this.mycontent.paging && this.mycontent.paging.page < this.mycontent.paging.total_pages ? this.mycontent.paging.page + 1 : null;
    },
    filteredContent() {
      return this.isFromMyContent ? this.mycontent.children && this.mycontent.children.filter((e) => e.id !== this.assetId) : this.mycontent.children;
    },
    filteredImages() {
      const e = this.filteredContent, s = [
        "3123b3ad-3c2d-49cf-92ce-9927c3c09e64",
        // image
        "1aa883f4-b310-4a5a-9d35-d07dc8cadf6c",
        // non-searchable-image
        "89cb88bc-1b04-4de2-8986-e82f65df2755"
        // folder
      ];
      return e.filter((o) => s.includes(o.type.id));
    },
    caretStatus() {
      return this.folderOpened ? "rotate--down" : "rotate--right";
    },
    isFolder() {
      return !!this.mycontent.children;
    },
    selected() {
      return !this.isChooseModal && this.mycontent.id === this.myContentModalStore.selectedFolder || this.myContentModalStore.selectedAssets.find((e) => e.id === this.mycontent.id);
    },
    showAddNewFolderActive() {
      return this.selected && this.myContentModalStore.isCreatingNewFolder;
    },
    isDisabled() {
      return this.folderTitle.length <= 1;
    },
    toggleFolderButtonLabel() {
      let e = "";
      return this.folderOpened ? e = this.$t("close %(name)s folder", {
        name: this.getLocalizedFolderName
      }) : e = this.$t("open %(name)s folder to reveal child folders", {
        name: this.getLocalizedFolderName
      }), e;
    },
    titleFolderButtonLabel() {
      let e = "";
      return this.folderOpened || this.folderOpened && this.selected ? e = this.$t("%(name)s folder selected", {
        name: this.getLocalizedFolderName
      }) : e = this.$t("select %(name)s folder to save content to it", {
        name: this.getLocalizedFolderName
      }), e;
    },
    getLocalizedFolderName() {
      let e = "";
      return e = this.mycontent.root ? this.$t(this.mycontent.title) : this.mycontent.title, e;
    }
  },
  setup() {
    return {
      myContentModalStore: x
    };
  },
  methods: {
    attachLoadMoreObserver() {
      this.loadMoreObserver = new IntersectionObserver((e) => {
        e.forEach((s) => {
          s.isIntersecting && (this.loadMoreItems(), this.loadMoreObserver.unobserve(s.target), this.loadMoreObserver = null);
        });
      }, {
        root: document.querySelector(".my-content__browse")
      }), this.loadMoreObserver.observe(this.$refs.loadMoreBanner);
    },
    async handleFolderToggleClick() {
      this.folderOpened ? this.folderOpened = !1 : (this.folderIsLoading = !0, this.folderOpened = !0, this.myContentModalStore.selectFolder(this.mycontent.id), this.mycontent.children.length || await this.myContentModalStore.fetchNestedFolder({
        id: this.mycontent.id,
        isChooseModal: this.isChooseModal,
        tab: this.selectedTab.type
      }), this.folderIsLoading = !1);
    },
    handleFolderTitleClick() {
      this.folderOpened ? this.myContentModalStore.selectFolder(this.mycontent.id) : this.handleFolderToggleClick();
    },
    loadMoreItems() {
      this.myContentModalStore.fetchNestedFolder({
        id: this.mycontent.id,
        isChooseModal: this.isChooseModal,
        page: this.nextPage,
        tab: this.selectedTab.type
      });
    },
    removeAddNewFolderForm() {
      this.myContentModalStore.showAddNewFolder(!1);
    },
    async createNewFolder() {
      const e = {
        folderParentId: this.myContentModalStore.selectedFolder || this.myContentModalStore.rootFolderIds[this.selectedTab.type],
        title: this.folderTitle,
        tab: this.selectedTab.type
      };
      this.folderIsLoading = !0, await this.myContentModalStore.addNewContentFolder(e), this.folderIsLoading = !1;
    },
    toggleAsset() {
      this.myContentModalStore.toggleSelectedAsset({
        id: this.mycontent.id,
        is_user_created: this.mycontent.is_user_created,
        title: this.mycontent.title,
        type: this.mycontent.type
      });
    }
  },
  mounted() {
    this.mycontent.root && this.mycontent.title !== "My Uploads" && (this.folderOpened = !0), this.nextPage && this.attachLoadMoreObserver();
  },
  beforeUnmount() {
    this.loadMoreObserver && this.loadMoreObserver.unobserve(this.$refs.loadMoreBanner);
  },
  watch: {
    nextPage(e) {
      e && !this.loadMoreObserver && this.$nextTick(() => {
        this.attachLoadMoreObserver();
      });
    },
    showAddNewFolderActive(e) {
      e && this.$nextTick(() => {
        this.$refs.addNewFolderInput.focus();
      });
    }
  }
}, ce = { role: "listitem" }, he = ["aria-label"], me = ["aria-label"], ye = ["id", "value", "checked"], ue = ["for"], fe = {
  key: 0,
  class: "folder__create"
}, pe = { class: "folder__form" }, be = ["placeholder", "aria-label"], ge = ["aria-label", "disabled"], Ce = ["aria-label"], Fe = {
  key: 0,
  class: "folder__browse browse-items",
  role: "list"
}, Me = {
  key: 2,
  ref: "loadMoreBanner",
  class: "folder folder--loading-indicator",
  role: "listitem"
}, _e = { class: "folder__selectable" };
function Te(e, s, o, d, l, t) {
  const a = u("LoadingSpinner"), h = u("NebulaIcon"), m = u("FolderParent", !0);
  return i(), c("div", ce, [
    n("div", {
      class: v(["folder", {
        "folder-parent": t.mycontent.root,
        opened: l.folderOpened
      }])
    }, [
      n("div", {
        class: v(["folder__selectable", {
          "folder__selectable--selected": t.selected
        }])
      }, [
        t.isFolder ? (i(), c(M, { key: 0 }, [
          n("button", {
            class: "folder__icon-btn",
            onClick: s[0] || (s[0] = (...r) => t.handleFolderToggleClick && t.handleFolderToggleClick(...r)),
            "aria-label": t.toggleFolderButtonLabel
          }, [
            l.folderIsLoading ? (i(), y(a, {
              key: 0,
              isLoading: ""
            })) : (i(), y(h, {
              key: 1,
              class: "comet-button__icon comet-button__icon--left",
              symbolId: "caret-up",
              size: "s",
              classOverride: t.caretStatus
            }, null, 8, ["classOverride"]))
          ], 8, he),
          n("button", {
            class: "folder__item",
            onClick: s[1] || (s[1] = (...r) => t.handleFolderTitleClick && t.handleFolderTitleClick(...r)),
            "aria-label": t.titleFolderButtonLabel
          }, [
            n("span", null, p(t.getLocalizedFolderName), 1)
          ], 8, me)
        ], 64)) : (i(), c(M, { key: 1 }, [
          n("input", {
            type: "checkbox",
            class: "folder__checkbox",
            id: `my-content-modal-asset--${t.mycontent.id}`,
            value: t.mycontent.id,
            checked: t.selected,
            onChange: s[2] || (s[2] = (...r) => t.toggleAsset && t.toggleAsset(...r))
          }, null, 40, ye),
          n("label", {
            for: `my-content-modal-asset--${t.mycontent.id}`,
            class: "folder__item folder__item--asset"
          }, [
            n("span", null, p(t.mycontent.title), 1)
          ], 8, ue)
        ], 64))
      ], 2),
      t.showAddNewFolderActive ? (i(), c("div", fe, [
        n("div", pe, [
          Z(n("input", {
            class: "folder__input comet-form__input",
            "onUpdate:modelValue": s[3] || (s[3] = (r) => l.folderTitle = r),
            placeholder: e.$t("Folder Name"),
            type: "text",
            "aria-label": e.$t("Enter folder name"),
            ref: "addNewFolderInput"
          }, null, 8, be), [
            [ee, l.folderTitle]
          ]),
          n("button", {
            class: v(["comet-button comet-button--primary", t.isDisabled && "comet-button--disabled"]),
            "aria-label": e.$t("Add folder"),
            onClick: s[4] || (s[4] = B((...r) => t.createNewFolder && t.createNewFolder(...r), ["prevent"])),
            disabled: t.isDisabled
          }, [
            C(h, {
              class: "comet-button__icon comet-button__icon--left",
              symbolId: "check",
              size: "s"
            })
          ], 10, ge),
          n("button", {
            class: "comet-button comet-button--danger",
            onClick: s[5] || (s[5] = B((...r) => t.removeAddNewFolderForm && t.removeAddNewFolderForm(...r), ["prevent"])),
            "aria-label": e.$t("Cancel adding folder")
          }, [
            C(h, {
              class: "comet-button__icon comet-button__icon--left",
              symbolId: "x",
              size: "s"
            })
          ], 8, Ce)
        ])
      ])) : f("", !0)
    ], 2),
    t.filteredContent && t.filteredContent.length ? (i(), c("div", Fe, [
      o.isImagesOnly ? (i(!0), c(M, { key: 0 }, A(t.filteredImages, (r) => (i(), y(m, {
        key: r.id,
        isChooseModal: o.isChooseModal,
        isFromMyContent: o.isFromMyContent,
        options: { myContent: r },
        selectedTab: o.selectedTab,
        isImagesOnly: o.isImagesOnly
      }, null, 8, ["isChooseModal", "isFromMyContent", "options", "selectedTab", "isImagesOnly"]))), 128)) : (i(!0), c(M, { key: 1 }, A(t.filteredContent, (r) => (i(), y(m, {
        key: r.id,
        isChooseModal: o.isChooseModal,
        isFromMyContent: o.isFromMyContent,
        options: { myContent: r },
        selectedTab: o.selectedTab,
        isImagesOnly: o.isImagesOnly
      }, null, 8, ["isChooseModal", "isFromMyContent", "options", "selectedTab", "isImagesOnly"]))), 128)),
      t.nextPage ? (i(), c("div", Me, [
        n("div", _e, [
          C(a, { isLoading: "" }),
          O(" " + p(e.$t("Loading more...")), 1)
        ])
      ], 512)) : f("", !0)
    ])) : f("", !0)
  ]);
}
const Ae = /* @__PURE__ */ w(ae, [["render", Te]]), ke = {
  name: "MyContentModal",
  components: {
    NebulaButton: P,
    NebulaModal: R,
    NebulaTabs: E,
    NebulaTabItem: j,
    FolderParent: Ae,
    LoadingSpinner: L
  },
  emits: [
    "chooseAssets",
    "closeModal",
    "success-add-asset-to-folder",
    "success-copy-asset-to-folder",
    "success-move-asset-to-trash",
    "asset-moved-or-copied",
    "success-move-asset-to-trash",
    "asset-restored"
  ],
  data() {
    return {
      actionPending: null,
      selectedTab: {
        type: "user",
        label: this.$t("My Content")
      },
      localUploadToken: null
    };
  },
  computed: {
    enableMoveToTrash() {
      var e;
      return !this.config.enableAddAction && ((e = this.asset) == null ? void 0 : e.actions[0]) === "trash";
    },
    modalIsActive() {
      return this.myContentModalStore.modalIsActive;
    },
    loadingFolders() {
      return this.myContentModalStore.loadingFolders;
    },
    selectedAssets() {
      return this.myContentModalStore.selectedAssets;
    },
    removeItemText() {
      const e = {
        chunk1: this.$t("Are you sure you want to move"),
        chunk2: `<span class="my-content--bold-text">${this.asset.selectedAssetTitle}</span>`,
        chunk3: this.$t("to your trash?")
      };
      return `${e.chunk1} ${e.chunk2} ${e.chunk3}`;
    },
    isMoveToTrash() {
      var e, s;
      return (s = (e = this.asset) == null ? void 0 : e.actions) == null ? void 0 : s.includes("trash");
    },
    normalizeEnableAddAction() {
      var e, s;
      return typeof ((e = this.config) == null ? void 0 : e.enableAddAction) > "u" || ((s = this.config) == null ? void 0 : s.enableAddAction);
    },
    useAddAction() {
      return this.normalizeEnableAddAction && !this.isMoveToTrash && !this.isChooseModal && !this.isFromMyContent;
    },
    chooseActions() {
      return [{
        type: "choose",
        label: this.$t("Choose"),
        method: "chooseAssets"
      }];
    },
    isChooseModal() {
      return this.config.modalType === "choose";
    },
    isStudent() {
      return this.config.isStudent || window.initData && window.initData.user.is_student;
    },
    isFromMyContent() {
      return this.asset && this.asset.requestingResource === "myContent";
    },
    isImagesOnly() {
      return this.config.imagesOnly;
    },
    modalDataIsValid() {
      return this.isChooseModal || this.subHeadingCopy;
    },
    myContentActions() {
      return [
        {
          type: "move",
          label: this.$t("Move"),
          pendingLabel: this.$t("Moving..."),
          method: "handleMoveAssetToFolder"
        },
        {
          type: "copy",
          label: this.$t("Copy"),
          pendingLabel: this.$t("Copying..."),
          method: "handleCopyAssetToFolder"
        },
        {
          type: "restore",
          label: this.$t("Restore"),
          pendingLabel: this.$t("Restoring..."),
          method: "handleRestoreAssetToFolder"
        },
        {
          type: "trash",
          label: this.$t("Move to trash"),
          pendingLabel: this.$t("Moving to trash..."),
          method: "handleMoveAssetToTrashFolder"
        }
      ];
    },
    tabs() {
      return [
        {
          type: "user",
          label: this.$t("My Content")
        },
        {
          type: "site",
          label: this.$t("School Content")
        },
        {
          type: "account",
          label: this.$t("District Content")
        }
      ];
    },
    hideDistrictTab() {
      return this.config.hideDistrictTab || window.initData && window.initData.hide_district_tab;
    },
    hideSchoolAndDistrict() {
      return this.asset && !this.asset.sharingEnabled || this.isStudent;
    },
    filteredTabs() {
      return this.hideSchoolAndDistrict ? this.tabs.filter((e) => e.type === "user") : this.hideDistrictTab ? this.tabs.filter((e) => e.type !== "account") : this.tabs;
    },
    availableActions() {
      if (this.isChooseModal) return this.chooseActions;
      const e = this.asset.actions || [];
      return this.myContentActions.filter((s) => e.includes(s.type) && this.getActionTabRestrictions(s.type));
    },
    bulkCopy() {
      const e = this.asset.bulk && this.asset.bulk.assets.length;
      return this.$t("%(num)d items", {
        num: e
      });
    },
    headingCopy() {
      return this.enableMoveToTrash ? this.$t("Move to trash") : this.config.modalType === "choose" ? this.$t("Choose from My Content") : this.isFromMyContent ? this.availableActions.map((e) => e.label).join("/") : this.$t("Save");
    },
    subHeadingCopy() {
      return this.asset.bulk ? this.bulkCopy : this.asset.selectedAssetTitle;
    }
  },
  setup() {
    return {
      myContentModalStore: x
    };
  },
  created() {
    this.config.baseURL && Q.interceptors.request.use((e) => ({
      ...e,
      baseURL: this.config.baseURL
    })), this.myContentModalStore.showModal(this.config.isActive);
  },
  mounted() {
    this.initOrCloseModal();
  },
  beforeUnmount() {
    this.focusOnTrigger();
  },
  methods: {
    chooseAssets() {
      this.$emit("chooseAssets", this.selectedAssets);
    },
    initModal() {
      const e = {
        config: { ...this.config, tab: this.selectedTab },
        isChooseModal: this.isChooseModal
      };
      this.myContentModalStore.initMyContent(e);
    },
    getActionTabRestrictions(e) {
      return (e === "move" || e === "restore") && !this.asset.sharingEnabled ? this.asset.currentTab === this.selectedTab.type : !0;
    },
    initOrCloseModal() {
      this.config.isActive ? this.initModal() : this.closeModal();
    },
    addNewFolder() {
      this.myContentModalStore.showAddNewFolder(!0);
    },
    async getUploadUrl() {
      const e = "/apiproxy/v1/";
      if (!this.localUploadToken) {
        const o = await T({
          baseURL: e
        });
        this.localUploadToken = o.tokens.upload;
      }
      return (await W({
        baseURL: e,
        folderId: this.myContentModalStore.selectedFolder,
        filename: this.asset.filename,
        contentType: "image/png",
        token: this.localUploadToken
      })).data;
    },
    async handleAddAssetToFolder() {
      if (this.actionPending = "add", this.asset.createdAsset)
        await this.addCreatedAssetToFolder(), this.actionPending = null;
      else if (this.asset.bulk) {
        const e = {
          folderId: this.myContentModalStore.selectedFolder,
          bulkAssets: this.asset.bulk.assets,
          tab: "user",
          token: this.asset.bulk.token
        };
        await X(e), this.actionPending = null, this.closeModal();
      } else {
        const e = {
          folderId: this.myContentModalStore.selectedFolder,
          assetId: this.asset.selectedAssetId,
          tab: this.selectedTab.type
        };
        this.actionPending = null;
        try {
          await this.myContentModalStore.addAssetToFolder(e), this.$emit("success-add-asset-to-folder", e), this.closeModal();
        } catch (s) {
          window.console.log(s);
        }
      }
    },
    async addCreatedAssetToFolder() {
      const e = await this.getUploadUrl(), { asset: s, fields: o, url: d } = e, l = new FormData();
      return Object.keys(o).forEach((t) => {
        l.append(t, o[t]);
      }), l.append("file", this.b64toBlob(this.asset.base64Img)), this.uploadFile(d, l), this.actionPending = null, this.closeModal(), s;
    },
    /**
     *  In math tools, a user-generated image returns a base64 string.
     *  We then need to turn that string into a blob to upload.
     */
    b64toBlob(e, s = "", o = 512) {
      const d = atob(e), l = [];
      for (let a = 0; a < d.length; a += o) {
        const h = d.slice(a, a + o), m = new Array(h.length);
        for (let b = 0; b < h.length; b += 1)
          m[b] = h.charCodeAt(b);
        const r = new Uint8Array(m);
        l.push(r);
      }
      return new Blob(l, { type: s });
    },
    async uploadFile(e, s) {
      let o;
      try {
        o = await z({
          method: "post",
          url: e,
          data: s,
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
      } catch (d) {
        window.console.log("error: ", d);
      }
      return o;
    },
    handleCopyAssetToFolder() {
      const e = {
        targetFolderId: this.myContentModalStore.selectedFolder,
        assetId: this.asset.selectedAssetId,
        tab: this.selectedTab.type
      };
      this.actionPending = "copy", this.myContentModalStore.copyAssetToFolder(e).then(() => {
        this.$emit("success-copy-asset-to-folder"), this.$emit("asset-moved-or-copied"), this.actionPending = null;
      });
    },
    handleMoveAssetToFolder() {
      const e = {
        targetFolderId: this.myContentModalStore.selectedFolder,
        assetId: this.asset.selectedAssetId,
        tab: this.selectedTab.type,
        currentFolderId: this.asset.parentFolderId
      };
      this.actionPending = "move", this.myContentModalStore.moveAssetToFolder(e).then(() => {
        this.$emit("asset-moved-or-copied"), this.actionPending = null;
      });
    },
    handleMoveAssetToTrashFolder() {
      const e = {
        targetFolderId: this.myContentModalStore.selectedFolder,
        assetId: this.asset.selectedAssetId,
        tab: this.selectedTab.type,
        currentFolderId: this.asset.parentFolderId
      };
      this.actionPending = "trash", this.myContentModalStore.moveAssetToTrash(e).then(() => {
        this.$emit("success-move-asset-to-trash"), this.actionPending = null;
      });
    },
    async handleRestoreAssetToFolder() {
      const e = {
        folderId: this.myContentModalStore.selectedFolder === "root" ? "" : this.myContentModalStore.selectedFolder,
        assetId: this.asset.selectedAssetId,
        tab: this.selectedTab.type
      };
      this.actionPending = "restore", this.myContentModalStore.restoreAssetFromTrash(e).then(() => {
        this.$emit("asset-restored"), this.actionPending = null;
      });
    },
    closeModal() {
      this.myContentModalStore.showModal(!1), this.$nextTick(() => {
        this.$emit("closeModal");
      });
    },
    focusOnTrigger() {
      if (this.asset) {
        const { selectedAssetId: e } = this.asset, s = document.getElementById(`action-menu--${e}`);
        s && s.focus();
      }
    },
    setSelectedTab(e) {
      this.selectedTab = this.tabs.find((s) => s.type === e);
    },
    isSelected(e) {
      return this.selectedTab && this.selectedTab.type === e;
    },
    getActionLabel(e) {
      return this.actionPending === e.type ? e.pendingLabel : e.label;
    },
    handleClick(e) {
      this[e]();
    },
    getInitialFocusElement() {
      var e, s, o;
      return (s = (e = this.$refs) == null ? void 0 : e.tabButtons) != null && s.length ? this.$refs.tabButtons[0] : (o = this.$refs) == null ? void 0 : o.closeButton;
    }
  },
  props: {
    asset: {
      selectedAssetId: {
        type: String
      },
      selectedAssetTitle: {
        type: String
      },
      parentFolderId: {
        type: String
      },
      actions: {
        type: Array
      },
      requestingResource: {
        type: String
      },
      sharingEnabled: {
        type: Boolean
      },
      currentTab: {
        type: String
      },
      bulk: {
        type: Object
      }
    },
    config: {
      baseURL: {
        type: String,
        required: !1
      },
      hideDistrictTab: Boolean,
      isActive: Boolean,
      isStudent: Boolean,
      modalType: {
        type: String,
        required: !1
      },
      type: Object,
      selectMultiple: {
        type: Boolean,
        default: !0
      },
      imagesOnly: {
        type: Boolean,
        default: !1
      },
      enableAddAction: {
        type: Boolean,
        default: !0
      }
    }
  },
  watch: {
    config: {
      handler() {
        this.initOrCloseModal();
      },
      deep: !0
    },
    asset: {
      handler() {
        this.initOrCloseModal();
      },
      deep: !0
    },
    selectedTab() {
      this.initOrCloseModal();
    },
    modalIsActive() {
      this.modalIsActive && this.isFromMyContent && (this.selectedTab = this.tabs.find((e) => e.type === this.asset.currentTab));
    }
  }
}, ve = { class: "my-content-modal__heading" }, Ie = {
  key: 0,
  class: "view my-content",
  index: "0",
  tabindex: "-1"
}, we = ["innerHTML"], Se = {
  key: 1,
  class: "my-content-modal__display-paragraph"
}, Be = {
  key: 1,
  class: "view my-content",
  index: "0",
  tabindex: "-1"
}, Ne = {
  key: 0,
  class: "my-content-modal__subheading"
}, Oe = { class: "my-content-text--bold" }, Le = { class: "my-content-modal__tabs-container" }, xe = {
  key: 1,
  class: "my-content__actions"
}, De = {
  class: "my-content__browse",
  id: "my-content__tab-panel"
}, Ue = {
  key: 1,
  class: "my-content__folder"
}, Pe = { class: "mode-content" }, Re = {
  class: "browse-items",
  role: "list"
};
function Ee(e, s, o, d, l, t) {
  const a = u("NebulaTabItem"), h = u("NebulaTabs"), m = u("NebulaButton"), r = u("LoadingSpinner"), b = u("FolderParent"), D = u("NebulaModal");
  return i(), y(N, {
    name: "nebula-modal-transition",
    mode: "out-in"
  }, {
    default: F(() => [
      t.modalIsActive && t.modalDataIsValid ? (i(), y(D, {
        key: 0,
        onCloseModal: t.closeModal,
        class: "my-content-modal js-comet-modal",
        size: "m"
      }, {
        header: F(() => [
          n("h2", ve, p(t.headingCopy), 1)
        ]),
        content: F(() => [
          t.enableMoveToTrash ? (i(), c("section", Ie, [
            l.actionPending ? (i(), c("p", Se, p(e.$t("Please wait while asset is moved to trash...")), 1)) : (i(), c("p", {
              key: 0,
              class: "my-content-modal__display-paragraph",
              innerHTML: t.removeItemText
            }, null, 8, we))
          ])) : (i(), c("section", Be, [
            t.isChooseModal ? f("", !0) : (i(), c("p", Ne, [
              O(p(e.$t("Select a destination for")) + " ", 1),
              n("span", Oe, p(t.subHeadingCopy), 1)
            ])),
            n("div", Le, [
              C(h, {
                "aria-label": e.$t("My Content tab navigation"),
                "role-tab-list": ""
              }, {
                tabs: F(() => [
                  (i(!0), c(M, null, A(t.filteredTabs, (g, S) => (i(), y(a, {
                    "aria-controls": "my-content__tab-panel",
                    key: S,
                    name: g.label,
                    selected: t.isSelected(g.type),
                    onClick: (je) => t.setSelectedTab(g.type),
                    ref_for: !0,
                    ref: "tabButtons",
                    role: "tab"
                  }, null, 8, ["name", "selected", "onClick"]))), 128))
                ]),
                _: 1
              }, 8, ["aria-label"])
            ]),
            t.isChooseModal ? f("", !0) : (i(), c("div", xe, [
              C(m, {
                onClick: t.addNewFolder,
                isDisabled: t.loadingFolders,
                "icon-left": "folder-add",
                text: e.$t("Add New Folder")
              }, null, 8, ["onClick", "isDisabled", "text"])
            ])),
            n("div", De, [
              t.loadingFolders ? (i(), y(r, {
                key: 0,
                isLoading: t.loadingFolders
              }, null, 8, ["isLoading"])) : (i(), c("div", Ue, [
                n("div", Pe, [
                  n("div", Re, [
                    C(b, {
                      isFromMyContent: t.isFromMyContent,
                      isChooseModal: t.isChooseModal,
                      options: { myContent: d.myContentModalStore.rootFolder },
                      assetId: o.asset ? o.asset.selectedAssetId : null,
                      selectedTab: l.selectedTab,
                      isImagesOnly: t.isImagesOnly
                    }, null, 8, ["isFromMyContent", "isChooseModal", "options", "assetId", "selectedTab", "isImagesOnly"]),
                    t.isChooseModal && l.selectedTab.type === "user" ? (i(), y(b, {
                      key: 0,
                      isFromMyContent: t.isFromMyContent,
                      isChooseModal: "",
                      options: { myContent: d.myContentModalStore.myUploadsFolder },
                      assetId: o.asset ? o.asset.selectedAssetId : null,
                      selectedTab: l.selectedTab,
                      isImagesOnly: t.isImagesOnly
                    }, null, 8, ["isFromMyContent", "options", "assetId", "selectedTab", "isImagesOnly"])) : f("", !0)
                  ])
                ])
              ]))
            ])
          ]))
        ]),
        actionsRow: F(() => [
          C(m, {
            ref: "closeButton",
            onClick: t.closeModal,
            type: "ghost",
            isDisabled: !!l.actionPending,
            text: e.$t("Close")
          }, null, 8, ["onClick", "isDisabled", "text"]),
          t.useAddAction ? (i(), y(m, {
            key: 0,
            onClick: t.handleAddAssetToFolder,
            isDisabled: !!l.actionPending || t.loadingFolders || t.isChooseModal && !t.selectedAssets.length,
            text: e.$t("Add")
          }, null, 8, ["onClick", "isDisabled", "text"])) : f("", !0),
          (i(!0), c(M, null, A(t.availableActions, (g) => (i(), y(m, {
            key: g.type,
            onClick: (S) => t.handleClick(g.method),
            isDisabled: !!l.actionPending || t.loadingFolders || t.isChooseModal && !t.selectedAssets.length,
            text: t.getActionLabel(g)
          }, null, 8, ["onClick", "isDisabled", "text"]))), 128))
        ]),
        _: 1
      }, 8, ["onCloseModal"])) : f("", !0)
    ]),
    _: 1
  });
}
const He = /* @__PURE__ */ w(ke, [["render", Ee]]);
export {
  He as default
};
